import { render, staticRenderFns } from "./BusinessHome.vue?vue&type=template&id=bb294eb0&scoped=true"
import script from "./BusinessHome.vue?vue&type=script&lang=js"
export * from "./BusinessHome.vue?vue&type=script&lang=js"
import style0 from "./BusinessHome.vue?vue&type=style&index=0&id=bb294eb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb294eb0",
  null
  
)

export default component.exports